import React from 'react';
import TableOrdinary from './TableOrdinary';
import TableCustomize from './TableCustomize';
import { useTranslation } from 'react-i18next';
import type { ConditionWithDetailTypeClient } from '../../../types/condition';

interface TableReviewProps {
  condition: ConditionWithDetailTypeClient;
}

const TableReview = ({ condition }: TableReviewProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {condition && condition.detailOrdinary.length > 0 && <TableOrdinary steelMaker={condition.steelMaker} businessType={condition.businessType} detailOrdinary={condition.detailOrdinary} />}
      {condition && condition.detailCustomize.length > 0 && <TableCustomize steelMaker={condition.steelMaker} businessType={condition.businessType} detailCustomize={condition.detailCustomize} />}
    </>
  );
};

export default TableReview;
